import { create, get, getByAsset, remove, update } from "api/space";
import flatMap from "lodash/flatMap";
import moment from "moment";

import { Translate } from "utils";
import { withInventory } from "utils/spaces";

const withDefaults = (space) => {
  const beginningOfDay = moment().startOf("day").format("L");

  return {
    ...space,
    availableFrom: withInventory(space.category) // eslint-disable-line
      ? space.status === "public" && space.capacity && space.capacity.value > 0
        ? beginningOfDay
        : null
      : space.availableFrom,
  };
};

export const getSpaces = (spaceIDs) => (dispatch) =>
  dispatch({
    type: "SPACES_GET",
    payload: get(spaceIDs),
    meta: { spaceIDs },
  });

export const getAllSpaces = () => (dispatch, getState) =>
  dispatch({
    type: "SPACES_ALL_GET",
    payload: get(flatMap(getState().assets, (a) => a.spaces.map((s) => s.id))),
    meta: {
      assetIDs: flatMap(getState().assets, (a) => a.spaces.map((s) => s.asset_id)),
    },
  });

export const getAssetSpaces = (assetID) => (dispatch) =>
  dispatch({
    type: "SPACES_ASSET_GET",
    payload: getByAsset(assetID),
    meta: { assetID },
  });

export const removeSpace = (spaceID) => (dispatch) =>
  dispatch({
    type: "SPACE_DELETE",
    payload: remove(spaceID),
    meta: { spaceID },
  });

export const addSpace = (space) => (dispatch) =>
  dispatch({
    type: "SPACE_ADD",
    payload: { space },
  });

export const createSpace = (space) => (dispatch) =>
  dispatch({
    type: "SPACE_CREATE",
    payload: create(space),
  });

export const getDealSpaces = (assetID) => (dispatch) =>
  dispatch({
    type: "SPACES_DEAL_GET",
    payload: getByAsset(assetID),
    meta: { assetID },
  });

export const saveSpace = (space) => (dispatch) => {
  if (space.id) {
    return dispatch({
      type: "SPACE_UPDATE",
      payload: update(withDefaults(space)),
      meta: { spaceID: space.id },
    });
  }

  return dispatch({
    type: "SPACE_CREATE",
    payload: create(withDefaults(space)),
  });
};

export const updateSpaceStatus = (space, status, excludeFromDigest) => (dispatch) =>
  dispatch({
    type: "SPACE_UPDATE_STATUS",
    payload: update(withDefaults({ ...space, status, excludeFromDigest })),
    meta: { spaceID: space.id, status },
  });

export const updateSpaceUnderOffer = (space, underOffer) => (dispatch) =>
  dispatch({
    type: "SPACE_UPDATE_UNDER_OFFER",
    payload: update({ id: space.id, underOffer }),
    meta: { spaceID: space.id, underOffer },
  });

export const editSpace = (spaceID) => (dispatch) =>
  dispatch({
    type: "SPACE_EDIT",
    meta: { spaceID },
  });

export const cancelEditSpace = (spaceID) => (dispatch) =>
  dispatch({
    type: "SPACE_EDIT_CANCEL",
    meta: { spaceID },
  });

export const duplicateSpace = (space) => (dispatch, getState) => {
  const { t } = new Translate("", getState().currentUser.company.locale);

  return dispatch({
    type: "SPACE_CREATE",
    payload: create({
      ...space,
      id: undefined,
      name: `${t("copy_of")} ${space.name}`,
      prices: space.prices.map((p) => ({ ...p, id: undefined })),
    }),
  });
};
